/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Merge_ButtonInputs */



/**
* | output |
* | --- |
* | "Merge Group" |
*
* @param {Merge_Event_Group_Merge_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_merge_button = /** @type {((inputs?: Merge_Event_Group_Merge_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Merge_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusionner le groupe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fusionsgruppe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unisci gruppo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа слияний")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fusionar grupo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("合并集团")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループを結合")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विलय समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de Fusão")
	return /** @type {LocalizedString} */ ("Merge Group")
});